export const MESSAGE_OUTBOX_REQUEST = 'MESSAGE_OUTBOX_REQUEST';
export const MESSAGE_OUTBOX_SUCCESS = 'MESSAGE_OUTBOX_SUCCESS';
export const MESSAGE_OUTBOX_FAIL    = 'MESSAGE_OUTBOX_FAIL';

